import uniqueId from 'lodash/uniqueId'

const advancedSearch = {
  state: {
    conditionList: [],
    defaultCondition: {
      conditionVos: [
        {
          conditionId: null,
          conditionType: null,
          conditionValues: [],
          parentConditionId: null,
          screenType: null,
          screenTypeText: "",
          values: [],
          myId: uniqueId([new Date().getTime()])
        }
      ],
      relationType: 2 // 默认定义为1
    },
    singleCondition: {
      conditionId: null,
      conditionType: null,
      conditionValues: [],
      parentConditionId: null,
      screenType: null,
      screenTypeText: "",
      values: [],
      myId: ''
    },
    groupCondition: {
      childOption: {},
      conditionId: null,
      conditionType: null,
      conditionValues: [],
      parentConditionId: null,
      screenType: null,
      screenTypeText: "",
      values: [],
      myId: ''
    },
    hasErr: false
    // { 单列 例子
    //   conditionId: 50,
    //   conditionType: 1,
    //   conditionValues: [{ label: "有", value: "1" }],
    //   parentConditionId: 2,
    //   screenType: 0,
    //   screenTypeText: "",
    //   values: ["1"],
    //   myId: uniqueId([new Date().getTime()])
    // }
  },
  mutations: {
    hasErr(state) {
      state.hasErr = true
    },
    hasErr(state) {
      state.hasErr = false
    },
    resetCondition(state) {
      state.defaultCondition = {
        conditionVos: [
          {
            conditionId: null,
            conditionType: null,
            conditionValues: [],
            parentConditionId: null,
            screenType: null,
            screenTypeText: "",
            values: [],
            myId: uniqueId([new Date().getTime()])
          }
        ],
        relationType: 2 // 默认定义为2
      }
    },
    setList(state, list) {
      state.conditionList = list
    },
    setSingleId(state) {
      state.singleCondition.myId = uniqueId([new Date().getTime()])
    },
    setGroupId(state) {
      state.groupCondition.myId = uniqueId([new Date().getTime()])
      state.singleCondition.myId = uniqueId([new Date().getTime()])
      state.groupCondition.childOption = {
        conditionVos: [state.singleCondition],
        relationType: 2
      }
    },
    setDefaultCondition(state, condition) {
      state.defaultCondition = condition
    }
  },
  getters: {
    conditionList(state){
      return state.conditionList
    },
    getSingleCondition(state) {
      return JSON.parse(JSON.stringify(state.singleCondition))
    },
    getGroupCondition(state) {
      return JSON.parse(JSON.stringify(state.groupCondition))
    },
    getDefaultCondition: state => state.defaultCondition,
  }

}


export default advancedSearch
